<template>
    <EditModal
        id="notenruecknahmeSVModal"
        title="Noten von Stimmvetreter zurücknehmen"
        :busy="busy"
        size="xl"
        buttonText="Zurücknehmen"
        scrollable
        @ok="dataProvide"
        @hidden="dataHide"
    >
        <NotenruecknahmeSV
            :svId="svId"
            :werkId="werkId"
            :notenId="notenId"
            :notentyp="notentyp"
            :validationData="validationData"
            @update="updateNotenruecknahme"
        />
    </EditModal>
</template>

<script>
import EditModal from "@/components/EditModal/EditModal";
import NotenruecknahmeSV from "@/components/Notentransfer/NotenruecknahmeSV";
import Toaster from "@/mixins/Toaster/Toaster";

export default {
    name: "NotenrücknahmeSVModal",
    mixins: [Toaster],
    components: { EditModal, NotenruecknahmeSV },
    props: ["svId", "werkId", "notenId", "notentyp", "busy", "validationData"],
    data() {
        return {
            data: null
        };
    },
    methods: {
        async dataProvide(evt) {
            evt.preventDefault();
            this.$emit("success", this.data);
        },
        dataHide() {
            this.dataCancel();
        },
        dataCancel() {
            this.data = null;
        },
        updateNotenruecknahme(data) {
            this.data = data;
        }
    }
};
</script>